import React from "react";
import { useNavigate } from "react-router-dom";
import LiveCoach from "../components/LiveCoach";

// Product-review route using the production LiveCoach + MediaPipe
// pipeline. Each entry intentionally includes the product/tool words
// the routine generator emits, so the same resolver used by real
// routines selects the matching landmark animation.
const BROW_DEMO_STEPS = [
  {
    title: "Pencil · Find your brow shape",
    category: "brows",
    what: "Let your natural brow lead. Find three quiet guide points: where your brow begins, where it naturally lifts, and where the tail finishes. These are landmarks, not lines, so your brow can stay soft.",
    where: "Map the brow head, natural arch, and tail before adding pencil.",
  },
  {
    title: "Pencil · Touch, flick, lift",
    category: "brows",
    what: "Start wherever the brow feels a little sparse. Rest the pencil lightly against the skin, flick one short stroke in the direction the hair already grows, then lift. Leave a little space between strokes so the brow stays airy.",
    where: "Fill only the sparse spaces with short, separate hair-like strokes.",
  },
  {
    title: "Pencil · Blend and soften",
    category: "brows",
    what: "Flip to the spoolie and keep the handle below the brush. Set the bristles into the inner brow and comb upward from the roots. As you move toward the tail, turn softly outward. One or two light passes will blend the pencil without brushing it away.",
    where: "Across the whole brow, from the inner brow head toward the tail.",
  },
  {
    title: "Microfilling pen · Build believable hairs",
    category: "brows",
    what: "Hold the microfilling pen lightly and add the finest hair-like strokes where you want a little more fullness. Follow your own hairs upward at the brow head, then softly outward through the arch and tail.",
    where: "Throughout the brows, following natural hair growth.",
  },
  {
    title: "Microfilling pen · Blend the new strokes",
    category: "brows",
    what: "Use the spoolie wand to comb upward and outward. A gentle pass softens the pen and helps every drawn stroke sit naturally beside the hairs already there.",
    where: "Across the whole brow, from the inner brow head toward the tail.",
  },
  {
    title: "Pomade · Define and feather",
    category: "brows",
    what: "Pick up the smallest amount of pomade and define the lower edge from the arch toward the tail. Use what remains to feather softly through the middle, keeping the inner brow light and airy.",
    where: "Along the lower edge of the brow, from arch to tail.",
  },
  {
    title: "Tinted gel · Share the color gently",
    category: "brows",
    what: "Wiggle the tinted gel wand softly at the roots, brush upward, then guide the hairs outward toward the tail. One light coat may be exactly enough.",
    where: "Across the whole brow, upward then outward.",
  },
  {
    title: "Clear gel · Lift what is already yours",
    category: "brows",
    what: "Comb the clear gel through the inner hairs upward, then follow their growth outward toward the tail. Take a quiet moment to let the gel set before touching it again.",
    where: "Across the whole brow, upward then outward.",
  },
  {
    title: "Styling wax · Press, lift, and shape",
    category: "brows",
    what: "Warm a little styling wax on the spoolie. Press the hairs upward from root to tip, shape them outward through the arch and tail, then pause so the lifted shape can set.",
    where: "Across the whole brow, pressing upward then outward.",
  },
];

export default function BrowCoachDemo() {
  const navigate = useNavigate();
  return (
    <LiveCoach
      steps={BROW_DEMO_STEPS}
      initialStepIdx={0}
      routineId={null}
      onClose={() => navigate("/")}
      onStepDone={() => {}}
      showAskTrouveAlways
    />
  );
}
